import { ComponentDefinitionBuilder } from 'nest/platform/models';
import { ACADEMY_VIDEO_HOST_COMPONENT, NC_PLATFORM_NAME } from '../constants';
import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../constants/z_index';
import { getAcademyQueryParams } from './internal/get-query-params';
import { ACADEMY_PIP_SESSION_KEY } from './academy-constants';
function hasVideoIdInSessionStorage() {
  try {
    const rawStoredVideoState = sessionStorage.getItem(ACADEMY_PIP_SESSION_KEY);
    const parsedRawStoredVideoState = JSON.parse(rawStoredVideoState || '{}');
    return Boolean(parsedRawStoredVideoState.videoId && !Number.isNaN(Number(parsedRawStoredVideoState.videoId)));
  } catch (e) {
    return false;
  }
}
export const academyVideoHostComponentDef = ComponentDefinitionBuilder.builder(ACADEMY_VIDEO_HOST_COMPONENT).setPath('/academy-navigation-components/:portalId/academy-video-host').setQueryParams(getAcademyQueryParams()).setCapabilityDefs([]).setPlatformName(NC_PLATFORM_NAME).setScrolling(false).setInitiallyOpen(true).dangerouslySetLoadInstantly(hasVideoIdInSessionStorage).setIframeProps({
  id: 'academy-video-host-iframe',
  ['data-test-id']: 'academy-video-host-iframe',
  title: 'academy-video-host-iframe',
  style: {
    position: 'fixed',
    zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
  }
}).build();